import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import history from '../history'


export default function useHistory() {
    const location = useLocation()
    const { pathname } = location


    const openVisualiztionWithTicker =  (uuid, ticker, feed)  => {
        // uuid && history.push({ pathname: '/visualization', search: `?projectId=${uuid}&feed=${feed}` })
        if (pathname != "/visualization"){
            let URL = window.location.href
            URL = URL.split(pathname)[0]
            uuid && window.open(`${URL}/visualization?projectId=${uuid}&feed=${feed}`, "_blank");}
        else{
            uuid && history.push({ pathname: '/visualization', search: `?projectId=${uuid}&feed=${feed}` })
        }
    }

    const goToPageNotFound = () => history.push({ pathname: '/PageNotFound'})
    
    return {
        openVisualiztionWithTicker,
        goToPageNotFound
    }
}
